import { IPageAddCallback, api } from "./index";
import { message } from "antd";
import { lang } from "../context";
import { PageType, PermissionEnum } from "../const";
import events from "../context/events";
import { getFileInfo } from "../reloadUtils";
import { joyspacePermissionType } from "../config/permissions.config";
import { ActionFnEnum, FileType } from "../types";
import { userSelectDataType } from "../util";
const clone: IPageAddCallback = (props: any, isAllow) => {
  const { data, reload, setData } = props;

  // if (!data.perms?.PAGE_CREATE) {
  //     return;
  // }
  return [
    {
      children: lang("ctx.clone.title"),
      icon: "pc_yundoc_fuben",
      splitCode: 2,
      callbackOrModal: () => {
        let newTitle = data.title
          ? data.title + lang("ctx.clone.dialog.title")
          : "无标题" + lang("ctx.clone.dialog.title");
        try {
          if (data.page_type === PageType.File) {
            const strs = data.title.split(".");
            if (strs.length >= 2) {
              const last = strs[strs.length - 1];
              strs[strs.length - 1] = lang("ctx.clone.dialog.title") + "." + last;
              newTitle = strs.join("");
            }
          }
        } catch (error) {}

        api.page.cloneResult(data.id, newTitle).then((res) => {
          const { data, status } = res;
          if (data) {
            getFileInfo(FileType.Page, data).then((res: any) => {
              if (res === joyspacePermissionType.ReadNothing || !res) {
                console.error("操作失败");
                return;
              }
              events.emit("list.reload");
              //   setData({ newItem: res, type: ActionFnEnum.ADD });
            });
            events.emit("list.check");
            message.success(lang("common.success"));
          } else {
            message.error(status);
          }
        });
      },
      isAllow,
      type: "clone",
      tip: "在当前位置创建一个副本文件，内容与原件一致，但两份文件互相独立。",
      allowTips: data.permissions.includes(PermissionEnum.SECURES_OPEN)
        ? "文档已开启安全设置，您暂无权限创建副本"
        : ""
    }
  ];
};

export default clone;
